import { render, staticRenderFns } from "./PromotionHub.vue?vue&type=template&id=c8fe4c9e"
import script from "./PromotionHub.vue?vue&type=script&lang=js"
export * from "./PromotionHub.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports